/**
 * Desktop sticky right pane on product page.
 * We rely on CSS position:sticky (product.css). The grid cell has the same height
 * as the photo column, so stickiness naturally ends when the last photo scrolls past.
 * This script is a no-op on desktop so it does not override the CSS; it only clears
 * any leftover inline styles from previous versions on load.
 */
(function () {
  const DESKTOP_BP = 768;

  function init() {
    const productInfo = document.querySelector('product-info.f-product-single');
    if (!productInfo) return;

    const pane = productInfo.querySelector('.f-product-single__info');
    if (!pane) return;

    if (window.innerWidth >= DESKTOP_BP) {
      /* Desktop: use CSS sticky only (no position:fixed). Clear any inline overrides so stylesheet wins. */
      pane.style.position = '';
      pane.style.top = '';
      pane.style.left = '';
      pane.style.width = '';
      pane.style.maxHeight = '';
      pane.style.overflowY = '';
      pane.style.zIndex = '';
      return;
    }

    /* Mobile: clear sticky-related inline styles if any */
    pane.style.position = '';
    pane.style.top = '';
    pane.style.left = '';
    pane.style.width = '';
    pane.style.zIndex = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
